import React, { ReactNode } from 'react';
import classNames from 'classnames';

import * as styles from './onboarding-page-title.scss';
import { useAnimationLatency } from '../utils/hooks';

interface Props {
  title: ReactNode;
  description?: ReactNode;
}

export const OnboardingPageTitle = ({ title, description }: Props) => {
  const showAnimatedTitle = useAnimationLatency(true);

  return (
    <div
      className={classNames(styles.fadeInContainer, {
        [styles.fadeIn]: showAnimatedTitle
      })}
    >
      <h1 className={styles.title} style={{ marginBottom: 10 }}>
        {title}
      </h1>
      {description && (
        <div className={styles.description} style={{ marginBottom: 20 }}>
          {description}
        </div>
      )}
    </div>
  );
};
